import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import { Button } from '@mui/material';
import { AlertTitle } from '@mui/material';
import ConfirmationAlert from 'components/Alert';
import * as React from 'react';
import webhookService from 'v2/services/webhook2';

type UnifyUrlData = {
  allUrlsAreUnified: boolean;
  duplicatedCount: number;
};

export default function UnifyDuplicatedUrl() {
  const [loading, setLoading] = React.useState<boolean>();
  const [data, setData] = React.useState<UnifyUrlData>({
    allUrlsAreUnified: true,
    duplicatedCount: 0,
  });

  const hasUrlsToUnify = async () => {
    try {
      const data = await webhookService.hasUrlsToUnify();

      setData(data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setLoading(true);
    hasUrlsToUnify();
  }, []);

  const askForConfirmation = async () => {
    const confirm = await ConfirmationAlert.show({
      message: (
        <>
          <p>
            Agora, você pode criar um Webhook para mais de 1 ou 2 produtos. Unifique suas URLs duplicadas e gerencie seus dados sem redundância,
            garantindo precisão em suas análises.
          </p>

          <Typography style={{ marginTop: 10 }} color='textSecondary'>
            * As mudanças podem levar até alguns minutos para serem refletidas.
          </Typography>
        </>
      ),
      title: 'Simplifique suas integrações com essa novidade!',
      confirmation: true,
    });

    if (confirm) {
      await webhookService.unifyUrls();
      setLoading(false);
      setData({
        allUrlsAreUnified: true,
        duplicatedCount: 0,
      });

      return;
    }
  };

  if (loading || data.allUrlsAreUnified) {
    return null;
  }

  return (
    <>
      <Alert
        severity='info'
        style={{ marginBottom: 30 }}
        action={
          <Button id='webhook-v2-button-unify-products' variant='outlined' onClick={() => askForConfirmation()}>
            Unificar Webhooks
          </Button>
        }
      >
        <AlertTitle>Temos uma novidade para você!</AlertTitle>

        <p>
          Agora, você pode configurar um webhook para receber notificações de diversos produtos em um mesmo webhook. Isso diminui a quantidade de
          configurações necessárias e facilita a integração com a nossa plataforma.
        </p>
      </Alert>
    </>
  );
}
